
import { _404, Biographies, Dashboard, Login, Memoirs, Subscription, Users } from "./routeImports";

import RequiredAuth from "@/utils/RequiredAuth";
import { RouteConstants } from "./routesConstants";
import { Navigate } from "react-router-dom";
import React from "react";

const RedirectionToDashboard = () => {
  return React.createElement(Navigate, { to: RouteConstants.dashboard });
};
const routesConfig = {
  common: [
    { path: "*", component: _404 },
  ],
  private: [
    {
      path: RouteConstants.home,
      index: true,
      component: RedirectionToDashboard,
    },
    {
      path:RouteConstants.dashboard,
      index:true,
      component:Dashboard
    },
    {
      path:RouteConstants.users,
      // index:true,
      component:Users
    },
     {
      path:RouteConstants.subscription,
      // index:true,
      component:Subscription
    },{
      path:RouteConstants.memoirs,
      component:Memoirs,
    },
    {
      path:RouteConstants.biographies,
      component:Biographies,
    }
   
  ],
  public: [
    { path: RouteConstants?.login, component: Login },
    {
      path: "*", // Catch-all route, can be used for a not-found page
      component: RequiredAuth,
    },
  ],
};

export default routesConfig;
